import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/containers/front-page-main-wrapper.tsx");
